module.exports = __webpack_public_path__ + "static/img/team_icon.d6fdb0a6.png";